import { memo } from 'react';
import { Typography } from '@mui/material';
import { RowChip } from 'components/common/SearchableBrowseItem/styledComponents';
import { getUiDefinitionContainerStyles, getUiDefinitionTextStyles } from 'utils/styles';
import { EMPTY_DISPLAY_LABEL } from '../utils/selectedRows';
import type { SelectedRow } from '../utils/selectedRows';

interface SelectedRecordChipProps {
  item: SelectedRow;
  onClick: (id?: string) => void;
}

export const SelectedRecordChip = memo(({ item, onClick }: SelectedRecordChipProps) => {
  const containerStyles = getUiDefinitionContainerStyles(item.formItemUiDefinition);
  const textStyles = getUiDefinitionTextStyles(item.formItemUiDefinition);

  const typographyStyles = Object.fromEntries(
    Object.entries({
      color: textStyles.color,
      fontWeight: textStyles.fontWeight,
      fontStyle: textStyles.fontStyle,
      textDecoration: textStyles.textDecoration,
    }).filter(([, value]) => value !== undefined)
  );

  return (
    <RowChip
      label={<Typography component="span">{item.value || EMPTY_DISPLAY_LABEL}</Typography>}
      onClick={() => onClick(item.id || undefined)}
      clickable
      sx={{
        ...(containerStyles.backgroundColor && { backgroundColor: containerStyles.backgroundColor }),
        ...(item.formItemUiDefinition?.columnBorderColor && {
          border: `1px solid ${item.formItemUiDefinition.columnBorderColor}`,
        }),
        ...(Object.keys(typographyStyles).length > 0 && { '& .MuiChip-label .MuiTypography-root': typographyStyles }),
        ...(item.wrapValue && {
          height: 'auto',
          '& .MuiChip-label': {
            whiteSpace: 'normal',
            '& .MuiTypography-root': { whiteSpace: 'normal', overflowWrap: 'anywhere' },
          },
        }),
      }}
    />
  );
});
